module.exports = __webpack_public_path__ + "static/media/1012967.f65188d3.jpg";